export default {
  CREATE_PROJECT: 'create_project',
  CREATE_REPORT: 'create_report',
  DASH: 'dash',
  DOCUMENT: 'document',
  EXPERIENCE: {
    ONBOARD_MODAL: 'onboarding_modal',
    VALUE_PATH: 'value_path',
  },
  GROUP: 'group',
  HOME_EMPTY_STATE_LOCATIONS: {
    COMPANY_PHOTOS: 'company_photos',
    COMPANY_PROJECTS: 'company_projects',
    NEARBY_LOAD_PROJECTS: 'nearby_load_projects',
    NEARBY_LOCATION_SETTINGS: 'nearby_location_settings',
    STARRED_PEOPLE: 'starred_people',
    STARRED_PROJECTS: 'starred_projects',
    USER_PHOTOS: 'user_photos',
    USER_PROJECTS: 'user_projects',
  },
  HOME_SCREEN_FOOTER: 'home_screen_footer',
  HOME_SCREEN_HEADER: 'home_screen_header',
  MOBILE: 'mobile',
  NAVIGATION: 'navigation',
  PAYMENT_METHOD_ACH: 'ach',
  PAYMENT_METHOD_CARD: 'card',
  PHOTO: 'photo',
  PROJECT_COLLABORATION: 'project_collaboration',
  PROJECT: 'project',
  SCAN_DOCUMENT: 'scan_document',
  SETTINGS: 'settings',
  SHARE_METHOD: {
    COPY_LINK: 'copy_link',
    OPEN_SHARE_SHEET: 'open_share_sheet',
  },
  TAKE_PHOTOS: 'take_photos',
  UPLOAD_PHOTOS: 'upload_photos',
  USER_MENU: 'user_menu',
  USER: 'user',
  USERS_AND_GROUPS: 'users_and_groups',
  VIDEO: 'video',
  WEB: 'web',
};
